import { Vue, Component, Inject } from "vue-property-decorator";

// Types
import {
  IUpgradeDowngradeProvider,
  IUpgradeDowngradeProviderMethods
} from "@/models/providers/upgradeDowngrades";

@Component
export default class UpgradeDowngradeInjectorMixin extends Vue {
  // Inject

  @Inject({ from: "upgradeDowngradeProvider" })
  private readonly $upgradeDowngradeProvider!: () => IUpgradeDowngradeProvider;

  @Inject({ from: "upgradeDowngradeProviderMethods" })
  public readonly $upgradeDowngradeMethods!: IUpgradeDowngradeProviderMethods;

  // Computed

  public get upgradeDowngradeData() {
    return this.$upgradeDowngradeProvider();
  }
}
